import WebService from "../WebService";

const Speaker = {
  gets(params) {
    return WebService.get("/speakers?" + params);
  },
  get(speaker_id, params) {
    return WebService.get(
      "/speakers/" + speaker_id +'?'+ params
      //  +'&'+ target+'_id='+target_id
    );
  },
  update(speaker_id,data) {
    return WebService.post("/speakers/" + speaker_id, data);
  },
  create(data) {
    return WebService.post("/speakers", data);
  }
};

export default Speaker;
